/**
 * Extrai o código de erro do XML que o S3 devolve.
 *
 * O axios não interpreta XML, então sem isto o operador vê apenas "Request
 * failed with status code 400" e a causa fica invisível — foi exatamente o que
 * aconteceu com `InvalidArgument` (Authorization duplicado) no primeiro teste
 * de upload em staging.
 *
 * Os códigos que mais aparecem neste fluxo:
 * - `InvalidArgument` — header de autenticação junto da URL assinada
 * - `AccessDenied` — URL expirada, ou credencial do Lambda sem permissão
 * - `EntityTooLarge` — arquivo além do limite do S3
 * - `BadDigest` — checksum enviado não corresponde ao corpo
 */
export const parseS3ErrorCode = (body: unknown): string | null => {
  if (typeof body !== 'string') return null;

  const match = body.match(/<Code>\s*([^<\s][^<]*?)\s*<\/Code>/);
  return match ? match[1] : null;
};
